import type { Listing } from '../types';
import { buildPhotos } from '../lib/photos';

// Vite globs require literal-string patterns, so we declare one pair per listing.
// Photos are emitted by scripts/generate-photos.mjs into src/assets/listings/<id>/
// as `NN-slug-WIDTH.{jpg,webp}` and bundled by Vite (hashed for caching).
const casagrandePhotos = buildPhotos(
  import.meta.glob('../assets/listings/casagrande/*.jpg', {
    eager: true,
    query: '?url',
    import: 'default',
  }) as Record<string, string>,
  import.meta.glob('../assets/listings/casagrande/*.webp', {
    eager: true,
    query: '?url',
    import: 'default',
  }) as Record<string, string>,
);

const fourwaysPhotos = buildPhotos(
  import.meta.glob('../assets/listings/fourways/*.jpg', {
    eager: true,
    query: '?url',
    import: 'default',
  }) as Record<string, string>,
  import.meta.glob('../assets/listings/fourways/*.webp', {
    eager: true,
    query: '?url',
    import: 'default',
  }) as Record<string, string>,
);

// Each listing surfaces eight amenities; values + labels are translated
// under listings.<id>.amenities.<key>.{label,value}. Keys differ per listing
// so each home can highlight what's actually distinctive on its Airbnb page.
const FOURWAYS_AMENITIES = [
  'power',
  'water',
  'wifi',
  'kitchen',
  'family',
  'outdoor',
  'service',
  'parking',
] as const;

const CASAGRANDE_AMENITIES = [
  'pool',
  'power',
  'wifi',
  'kitchen',
  'bathrooms',
  'climate',
  'outdoor',
  'parking',
] as const;

// Both homes sit inside the same Broadacres estate and share neighbourhood
// landmarks, so the keys are shared but values are per-listing in locales.
const NEARBY_KEYS = ['n1', 'n2', 'n3', 'n4'] as const;

export const listings: Listing[] = [
  {
    id: 'fourways',
    airbnbUrl: 'https://www.airbnb.co.za/h/fourways-gatheringnest',
    guests: 8,
    bedrooms: 4,
    beds: 4,
    baths: 2.5,
    // TODO: refresh rating + reviews from Airbnb listing once available.
    // rating: 0,
    // reviews: 0,
    price: 3500,
    minNights: 5,
    photos: fourwaysPhotos,
    // Obscured center within Broadacres — never the exact address.
    area: { lat: -25.999, lng: 27.99 },
    amenityKeys: FOURWAYS_AMENITIES,
    nearbyKeys: NEARBY_KEYS,
  },
  {
    id: 'casagrande',
    airbnbUrl: 'https://www.airbnb.co.za/rooms/1666553411719929192',
    guests: 8,
    bedrooms: 4,
    beds: 4,
    baths: 3.5,
    // TODO: refresh rating + reviews from Airbnb listing once available.
    // rating: 0,
    // reviews: 0,
    price: 4000,
    minNights: 5,
    photos: casagrandePhotos,
    // Obscured center within Broadacres — never the exact address.
    area: { lat: -25.996, lng: 27.994 },
    amenityKeys: CASAGRANDE_AMENITIES,
    nearbyKeys: NEARBY_KEYS,
  },
];

export function getListingById(id: string | undefined): Listing | undefined {
  return listings.find((l) => l.id === id);
}

export function getOtherListing(currentId: string): Listing | undefined {
  return listings.find((l) => l.id !== currentId);
}
